import {
    CANCEL_BOOKING_GET_DETAIL_START,
    CANCEL_BOOKING_GET_DETAIL_SUCCESS,
    CANCEL_BOOKING_GET_DETAIL_ERROR,
  } from "Constant";
  
  const initialState = {
    loading: false,
    data: null
      // data:null
      
  };
  
  export default function CancelBookingReducer(
    state = { ...initialState },
    action
  ) {
    switch (action.type) {
      case CANCEL_BOOKING_GET_DETAIL_START:
        return {
          ...state,
          loading: true,
        };
      case CANCEL_BOOKING_GET_DETAIL_SUCCESS:
        return {
          ...state,
          data: action.payload,
          loading: false,
        };
      case CANCEL_BOOKING_GET_DETAIL_ERROR:
        return {
          ...state,
          loading: false,
          message: action.error.message,
        };
      default:
        return state;
    }
  }
  